import { GetGlobalColor } from "../../utils/globalColors";

export const Button = ({ onClick, text, text2 = null, icon }) => {
      const color = GetGlobalColor();
    return (
        <div className={`flex flex-col  mt-20 mr-2`}>
            <button className={`h-14 w-14 icons wtext rounded-full flex items-center justify-center card-bg-${color}`} onClick={onClick}>
                <i className={"fa fa-"+icon}></i>
            </button>

            <span className="wtext">
                <span style={{ display: "block" }} >{text}</span>
                <span style={{ display: "block" }}>{text2}</span>
            </span>

  

        </div>
    );
};



